import { PlaceHolder } from './PlaceHolder';

export default PlaceHolder;
